import { CardImagePizza } from "components/card/card_image/card_image_pizza/card_image_pizza";
import { CardHolder } from "components/card_holder/card_holder";
import { Footer } from "components/footer/footer";
import { NavigationBarHeader } from "components/navbar/navbar_pizza";
import { Loading } from "pages/loading/loading";
import { filterPizzaNouveaute } from "utils/filters/filterPizzaNouveaute";
import Transitions from "utils/transition";
import { useStrapi } from "hooks/use-strapi";

export function Nouveautes() {
  const {
    data: pizzaBasique,
    loading: loadingPizzaBasique,
    error: errorPizzaBasique,
  } = useStrapi("cg-pizza-basiques");
  const {
    data: pizzaClassique,
    loading: loadingPizzaClassique,
    error: errorPizzaClassique,
  } = useStrapi("cg-pizza-classiques");
  const {
    data: pizzaGourmande,
    loading: loadingPizzaGourmande,
    error: errorPizzaGourmande,
  } = useStrapi("cg-pizza-gourmandes");
  const {
    data: pizzaDessert,
    loading: loadingPizzaDessert,
    error: errorPizzaDessert,
  } = useStrapi("cg-pizza-desserts");
  const {
    data: etablissement,
    loading: loadingEtablissement,
    error: errorEtablissement,
  } = useStrapi("cg-etablissement");

  if (
    errorEtablissement ||
    errorPizzaDessert ||
    errorPizzaBasique ||
    errorPizzaClassique ||
    errorPizzaGourmande
  ) {
    return <div>Une erreur est survenue</div>;
  }

  if (
    loadingEtablissement ||
    loadingPizzaDessert ||
    loadingPizzaBasique ||
    loadingPizzaClassique ||
    loadingPizzaGourmande
  ) {
    return <Loading />;
  }

  let pizzas = [];
  pizzas = pizzas.concat(pizzaBasique);
  pizzas = pizzas.concat(pizzaClassique);
  pizzas = pizzas.concat(pizzaGourmande);
  pizzas = pizzas.concat(pizzaDessert);

  let pizzasFiltered = filterPizzaNouveaute(pizzas);

  return (
    <>
      <Transitions className="transition">
        <NavigationBarHeader />
        <CardHolder>
          {pizzasFiltered.map((value) => {
            return (
              <CardImagePizza data={value} key={value.id}></CardImagePizza>
            );
          })}
        </CardHolder>
        <Footer
          adress={etablissement.Adresse}
          contact={etablissement.Telephone}
        />
      </Transitions>
    </>
  );
}
